export default __webpack_public_path__ + "static/media/mitchell-orr-rcG2VqAKJdA-unsplash.1c3486ef.jpg";